(function () {


    const showEvent = new CustomEvent("show.bs.collapse", {
        bubbles: true,
        cancelable: true
    })
    const hideEvent = new CustomEvent("hide.bs.collapse", {
        bubbles: true,
        cancelable: true
    })

    function show(element) {
        if (!window.bootstrap) {
            const target = element.dataset.bsTarget
            const targetElement = target ? document.getElementById(target.substring(1)) : null
            const target2 = element.dataset.target2;
            const targetElement2 = target2 ? document.getElementById(target2.substring(1)) : null;

            if (targetElement) {
                targetElement.classList.add("show")
                element.setAttribute("aria-expanded", "true")
                element.classList.remove("collapsed")
                if (targetElement2) {
                    targetElement2.classList.add("expanded");
                }
                targetElement.dispatchEvent(showEvent)
            }
        } else {
            // bootstrap is handling so will be hiding - not showing
            const target2 = element.dataset.target2;
            console.log("target2", target2)
            const targetElement2 = target2 ? document.getElementById(target2.substring(1)) : null;
            if (targetElement2) {
                targetElement2.classList.remove("expanded");
            }

        }
    }

    function hide(element) {
        if (!window.bootstrap) {
            const target = element.dataset.bsTarget
            const targetElement = target ? document.getElementById(target.substring(1)) : null
            const target2 = element.dataset.target2;
            const targetElement2 = target2 ? document.getElementById(target2.substring(1)) : null;

            if (targetElement) {
                targetElement.classList.remove("show")
                element.setAttribute("aria-expanded", "false")
                element.classList.add("collapsed")
                targetElement.dispatchEvent(hideEvent)
                if (targetElement2) {
                    targetElement2.classList.remove("expanded");
                }
                targetElement.dispatchEvent(hideEvent)
            }
        } else {
            // bootstrap is handling so will be showing - not hiding
            console.log("got one!")
            const target2 = element.dataset.target2;
            console.log("target2", target2)
            const targetElement2 = target2 ? document.getElementById(target2.substring(1)) : null;
            if (targetElement2) {
                targetElement2.classList.add("expanded");
            }

        }
    }

    const collapsers = document.querySelectorAll('[data-bs-toggle="collapse"]');
    if (collapsers) {
        console.log("collapsers!")
        collapsers.forEach((element) => {
            document.addEventListener('keydown', function (event) {
                if (!window.bootstrap) {
                    if (event.key === 'Escape') {
                        hide(element)
                    }
                }
            });
            element.onclick = function (e) {

                e.preventDefault()
                const expanded = element.getAttribute("aria-expanded") == "true"
                console.log("clicked on a collapser", element, !expanded)

                if (!expanded) {
                    show(element)
                } else {
                    hide(element)
                }
            }

        })
    }
})();